import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 200px;
  background: ${(props) => props.theme.colors.surface_muted};
  border-radius: 6px;
  min-width: fit-content;

  .avatar {
    margin: 8px 0 8px 8px;
    
    img {
      width: 36px;
      height: 36px;
      border-radius: 100px;
      object-fit: cover;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 3px;

    .name {
      font-size: 16px;
      padding-bottom: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 135px;
    }

    .licenseName {
      font-size: 13px;
      color:  ${(props) => props.theme.colors.inactive};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 135px;
      line-height: 17px;
    }
  }
`;

export default { Wrapper };
